<header
  class="flex items-center justify-between py-lg border-b border-neutral-200">
  <h6 class="text-neutral-900 font-semibold text-lg px-lg">
    {{ 'security_tab_title' | transloco }}
  </h6>

  <a
    class="cursor-pointer flex items-center gap-sm px-xl py-sm font-medium text-primary-600 text-base"
    id="profile_tab_edit_button"
    (click)="openModal()">
    <lib-edit-icon [iconClass]="'size-5 text-primary-600'" />

    {{ 'security_tab_change_password_button' | transloco }}
  </a>
</header>

<section class="info-items-container gap-lg">
  <div class="flex flex-col mt-lg">
    <label class="view-mode-label">
      {{ 'security_tab_password_label' | transloco }}
    </label>

    <p class="view-mode-value break-word text-neutral-900">
      {{ 'security_tab_asterisk_label' | transloco }}
    </p>
  </div>
</section>

<ng-template #changePasswordModal>
  <div class="rounded-xl">
    <form [formGroup]="changePasswordForm()" class="create-form">
      <div class="mb-2xl">
        <h5 class="text-2xl font-semibold mb-md text-neutral-900">
          {{ 'change_password_screen_change_password_header' | transloco }}
        </h5>

        <p class="font-medium text-sm text-neutral-500">
          {{ 'change_password_screen_change_password_sub_header' | transloco }}
        </p>
      </div>

      <div class="flex flex-col gap-lg">
        <div class="w-full">
          <lib-input
            [label]="
              'change_password_screen_current_password_label' | transloco
            "
            [placeholder]="
              'change_password_screen_current_password_placeholder' | transloco
            "
            id="current_password"
            inputFormControlName="current_password"
            [startIconTemplate]="lockIconTemplate"
            [endIconTemplate]="
              !showCurrentPassword ? eyeIconTemplate : eyeHiddenIconTemplate
            "
            (endIconCLick)="showCurrentPassword = !showCurrentPassword"
            [type]="showCurrentPassword ? 'text' : 'Password'"
            name="current_password" />

          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="current_password" />
        </div>

        <div class="w-full">
          <lib-input
            [label]="'change_password_screen_new_password_label' | transloco"
            [placeholder]="
              'change_password_screen_new_password_placeholder' | transloco
            "
            id="new_password"
            inputFormControlName="new_password"
            [startIconTemplate]="lockIconTemplate"
            [endIconTemplate]="
              !showPassword ? eyeIconTemplate : eyeHiddenIconTemplate
            "
            (endIconCLick)="showPassword = !showPassword"
            [type]="showPassword ? 'text' : 'Password'"
            name="new_password" />

          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="new_password" />
        </div>

        <div class="w-full">
          <lib-input
            [label]="
              'change_password_screen_confirm_password_label' | transloco
            "
            [placeholder]="
              'change_password_screen_confirm_password_placeholder' | transloco
            "
            id="new_password_confirmation"
            inputFormControlName="new_password_confirmation"
            [startIconTemplate]="lockIconTemplate"
            [endIconTemplate]="
              !showConfirmationPassword
                ? eyeIconTemplate
                : eyeHiddenIconTemplate
            "
            (endIconCLick)="
              showConfirmationPassword = !showConfirmationPassword
            "
            [type]="showConfirmationPassword ? 'text' : 'Password'"
            name="new_password_confirmation"></lib-input>
          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="new_password_confirmation"></lib-validation-message>
        </div>
      </div>

      <div class="password-validation mt-lg mb-4xl">
        <div
          [class.valid]="passwordValidationStatus.length"
          [class.invalid]="
            !passwordValidationStatus.length && passwordValidationStatus.touched
          ">
          {{ 'create_password_screen_password_requirement_1' | transloco }}
        </div>
        <div
          [class.valid]="passwordValidationStatus.upperCase"
          [class.invalid]="
            !passwordValidationStatus.upperCase &&
            passwordValidationStatus.touched
          ">
          {{ 'create_password_screen_password_requirement_2' | transloco }}
        </div>
        <div
          [class.valid]="passwordValidationStatus.lowerCase"
          [class.invalid]="
            !passwordValidationStatus.lowerCase &&
            passwordValidationStatus.touched
          ">
          {{ 'create_password_screen_password_requirement_3' | transloco }}
        </div>
        <div
          [class.valid]="passwordValidationStatus.number"
          [class.invalid]="
            !passwordValidationStatus.number && passwordValidationStatus.touched
          ">
          {{ 'create_password_screen_password_requirement_4' | transloco }}
        </div>
        <div
          [class.valid]="passwordValidationStatus.specialChar"
          [class.invalid]="
            !passwordValidationStatus.specialChar &&
            passwordValidationStatus.touched
          ">
          {{ 'create_password_screen_password_requirement_5' | transloco }}
        </div>
      </div>

      <div class="flex flex-col gap-md text-base font-medium">
        <button
          (click)="changePassword()"
          [class.opacity-30]="
            isChangeButtonDisabled() || !changePasswordForm().valid
          "
          [disabled]="isChangeButtonDisabled() || !changePasswordForm().valid"
          class="bg-primary-500 py-sm rounded-md text-white text-base cursor-pointer">
          {{ 'change_password_modal_change_password_button' | transloco }}
        </button>

        <button
          (click)="closeModal()"
          class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
          {{ 'change_password_modal_discard_button' | transloco }}
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #lockIconTemplate>
  <lib-lock-icon [iconClass]="'size-5 text-neutral-900'" />
</ng-template>

<ng-template #eyeIconTemplate>
  <lib-view-icon [iconClass]="'size-5 text-neutral-900'" />
</ng-template>

<ng-template #eyeHiddenIconTemplate>
  <lib-eye-hidden-icon [iconClass]="'size-5 text-neutral-900'" />
</ng-template>
